import { http } from './http.jsx';

export const employeeService = {
  // Get all employees
  getEmployees: (params = {}) => http.get('/api/admin/employees', { params }),
  
  // Get single employee
  getEmployee: (employeeId) => http.get(`/api/admin/employees/${employeeId}`),
  
  // Create new employee
  createEmployee: (data) => http.post('/api/admin/employees', data),
  
  // Update employee
  updateEmployee: (employeeId, data) => http.put(`/api/admin/employees/${employeeId}`, data),
  
  // Delete employee
  deleteEmployee: (employeeId) => http.delete(`/api/admin/employees/${employeeId}`),
  
  // Get departments for dropdown
  getDepartments: () => http.get('/api/admin/employees-departments'),
  
  // Get positions for dropdown
  getPositions: () => http.get('/api/admin/employees-positions'),
  
  // Get employment types for dropdown
  getTypes: () => http.get('/api/admin/employees-types'),
};
